import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { BRANDS } from "../lib/site";
import { Seo } from "../components/Seo";

export default function Brands() {
  return (
    <div data-testid="page-brands">
      <Seo
        path="/brands"
        title="Import Brands We Specialize In — BMW, Audi, VW, Mercedes, Subaru, Porsche"
        description="Factory-grade BMW, Audi, Volkswagen, Mercedes-Benz, Subaru and Porsche service in Hermiston, OR. M-series, RS / S-line, GTI / Golf R, AMG, WRX / STI and 911 specialists."
      />
      <PageHeader
        code="// 01"
        kicker="Marques"
        title={<>The six we<br />speak fluently.</>}
        subtitle="BMW, Audi, Volkswagen, Mercedes-Benz, Subaru and Porsche. Each one gets its own factory scan tool, its own torque specs, its own service intervals — and our full attention."
        testId="brands-header"
      />

      <section className="px-6 md:px-12 lg:px-24 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 border border-white/10">
          {BRANDS.map((b, i) => {
            const Icon = b.icon;
            return (
              <article
                key={b.key}
                data-testid={`brand-card-${b.key}`}
                className="group relative bg-[#0A0A0A] hover:bg-[#1A1F24] transition-colors p-8 md:p-12 min-h-[280px] flex flex-col justify-between overflow-hidden"
              >
                <div className="flex items-start justify-between">
                  <div className="flex items-center gap-5">
                    <Icon className="w-20 h-20 md:w-24 md:h-24 text-white/40 group-hover:text-white transition-colors" />
                    <div>
                      <div className="font-mono-tech text-[10px] text-[#FF3B30] tracking-[0.3em]">{`0${i + 1}`}</div>
                      <h2 className="font-display font-black uppercase tracking-tighter text-3xl md:text-4xl mt-1">{b.name}</h2>
                    </div>
                  </div>
                </div>
                <p className="text-white/65 leading-relaxed mt-6 max-w-md">{b.blurb}</p>
                <div className="mt-6 flex items-center gap-2 font-mono-tech text-[10px] text-white/40 uppercase tracking-[0.25em]">
                  <span className="h-px w-8 bg-[#FF3B30]" /> Specialist work
                </div>
              </article>
            );
          })}
        </div>

        <div className="mt-16 bg-[#1A1F24] border border-white/10 p-8 md:p-12 flex flex-col md:flex-row justify-between gap-6 md:items-center">
          <div>
            <div className="font-mono-tech text-[11px] text-[#FF3B30] tracking-[0.3em] uppercase">// no job too small</div>
            <h3 className="font-display font-black uppercase tracking-tight text-2xl md:text-3xl mt-2">
              Don't see your make? Bring it in anyway.
            </h3>
            <p className="text-white/65 mt-3 max-w-xl">
              The six marques above are our specialty — but we still work on everything else. Domestics, trucks, motorcycles, you name it. No job is too small.
            </p>
          </div>
          <Link
            to="/contact"
            data-testid="brands-contact-cta"
            className="group inline-flex items-center gap-3 bg-[#FF3B30] hover:bg-[#FF5722] text-white text-xs font-bold uppercase tracking-[0.25em] px-7 py-4 transition-colors self-start"
          >
            Bring it in
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
      </section>
    </div>
  );
}
